import { useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Grid2,
  IconButton,
  Card,
  CardContent,
  Divider,
  Grid,
} from "@mui/material";
import { ReactComponent as LoadIcon } from "../../../images/loadExampleButton.svg";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import { useLocation, useNavigate } from "react-router-dom";
import CommonAccordion from "../../custom-components/CommonAccordion";
import SendIcon from "@mui/icons-material/Send";

const SummaryReportScope = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [inScope, setInScope] = useState("");
  const [outofscope, setOutofScope] = useState("");

  const isDetailsFilled = inScope.trim() !== "" && outofscope.trim() !== "";

  const outerContainerStyle = {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F6F3F2", // Updated background color
  };

  const handleScopeNext = async () => {
    try {
      let scopeData = {
        inScope: inScope,
        outofscope: outofscope,
      };
      navigate("/dashboard/sprint-summary-report/output", {
        state: { ...location.state, scopeData: scopeData },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormLoadDemoExample = (e) => {
    e.stopPropagation();
    setInScope("In Scope: User should be able to login to the application");
    setOutofScope(
      "Out of Scope: User should not be able to login to the application"
    );
  };

  return (
    <CommonAccordion
      summary={
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle1" sx={{ fontSize: "16px" }}>
            Scope
          </Typography>
          <Button
            variant="text"
            startIcon={<LoadIcon />}
            sx={{
              ml: 2,
              textTransform: "none",
              position: "relative",
              top: "0px",
            }}
            onClick={handleFormLoadDemoExample}
          >
            Load Demo Example
          </Button>
        </Box>
      }
      details={
        <Box sx={{ padding: "24px" }}>
          <Grid container spacing={2}>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px dashed #49A3FF",
                borderRadius: "8px",
                padding: "14px",
                cursor: "pointer",
                width: "95%",
                backgroundColor: "#F8FBFF",
                color: "#000",
                fontSize: "14px",
                textAlign: "center",
                fontWeight: 500,
              }}
            >
              <ContentPasteSearchIcon sx={{ mr: 1 }} />
              Import User Stories
            </Box>
            <Divider
              sx={{
                mt: 3,
                color: "gray",
                fontSize: "14px",
                width: "95%", // Ensures it aligns with the box above
              }}
              variant="middle" // Centers the text within the divider
            >
              <Typography sx={{ color: "gray", fontSize: "14px" }}>
                OR
              </Typography>
            </Divider>
            {/* In Scope */}
            <Grid xs={12} sx={{ marginTop: 2 }}>
              <TextField
                label="In Scope"
                fullWidth
                placeholder="Enter In Scope"
                variant="outlined"
                multiline
                rows={4}
                value={inScope}
                onChange={(e) => setInScope(e.target.value)}
              />
            </Grid>
            {/* Out of Scope */}
            <Grid sx={{ marginTop: 3 }} xs={12}>
              <TextField
                label="Out of Scope"
                fullWidth
                placeholder="Enter Out of Scope"
                variant="outlined"
                multiline
                rows={4}
                value={outofscope}
                onChange={(e) => setOutofScope(e.target.value)}
              />
            </Grid>
          </Grid>
        </Box>
      }
      buttons={[
        {
          label: "Next",
          variant: "contained",
          startIcon: <SendIcon />,
          onClick: handleScopeNext,

          sx: {
            float: "right",
            textTransform: "none",
            backgroundColor: isDetailsFilled ? "#49A3FF" : "grey",
            color: isDetailsFilled ? "white" : "black",
            "&:hover": {
              backgroundColor: isDetailsFilled ? "#49A3FF" : "darkgrey",
            },
          },
          disabled: !isDetailsFilled,
        },
      ]}
      type={"input"}
      defaultExpanded={true}
    />
  );
};

// Centering the card in the middle of the page
const outerContainerStyle = {
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#f0f2f5",
};

// Card Styling
const cardStyle = {
  width: "50%",
  paddingX: "0px",
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "white",
  borderRadius: "8px",
};

// Date Box Styling
const dateBoxStyle = {
  border: "1px solid lightgray",
  borderRadius: "4px",
  padding: "8px",
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  backgroundColor: "#f5f5f5",
};

export default SummaryReportScope;
